<section [title]="title()">
  <div detail>
    <div fieldset>
      <div field>
        <span label>Customer Number</span>
        <span value>{{ savedCart()?.customerNumber }}</span>
      </div>
      <div field>
        <span label>Updated On</span>
        <span value>{{ savedCart()?.updated | date: "medium" }}</span>
      </div>
      <div field>
        <span label>Created On</span>
        <span value>{{ savedCart()?.created | date: "medium" }}</span>
      </div>
    </div>
    <div actions>
      <ideal-cart-stepper-input [control]="control" label="Multiple" [(quantity)]="multiple"></ideal-cart-stepper-input>
      <button mat-flat-button (click)="addToCart()">
        <mat-icon>add_shopping_cart</mat-icon>
        <span>Add to Cart</span>
      </button>
    </div>
  </div>
</section>

<ideal-saved-cart-item-results></ideal-saved-cart-item-results>
